const headerEl = document.getElementById("header");
const sentinelEl = document.createElement("div");

const thresholt = 100;

if (headerEl) {
  // Adding a sentinel element to track the scroll position
  sentinelEl.style.position = "absolute";
  sentinelEl.style.top = `${thresholt}px`;
  document.body.prepend(sentinelEl);

  // Function to handle intersection changes
  const handleIntersect = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        headerEl.classList.remove("resized");
        sentinelEl.style.top = `${thresholt}px`;
      } else {
        headerEl.classList.add("resized");
        sentinelEl.style.top = `${thresholt - 20}px`;
      }
    });
  };

  // Intersection Observer configuration
  const observer = new IntersectionObserver(handleIntersect, {
    threshold: [0],
  });

  // Start observing the sentinel element
  observer.observe(sentinelEl);
}
